var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-box"},[(_vm.useType == 'select')?_c('div',{attrs:{"id":"tip"}},[_c('input',{attrs:{"type":"text","id":"keyword","name":"keyword","value":"请输入关键字：(选定后搜索)","onfocus":"this.value=\"\""}})]):_vm._e(),_c('div',{ref:"container",staticClass:"container",attrs:{"id":"container"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }